import React from 'react';
import styled from 'styled-components';

import { SkeletonBlock } from '@/components/common/loaders/SkeletonBlock';
import { media } from '@/styles/theme';

const ResourcesClientHomeSkeleton = (): React.ReactElement => {
  return (
    <SkeletonContainer>
      <SkeletonTitle />
      <SkeletonCardsContainer>
        {[...Array(4)].map((_, idx) => (
          <SkeletonCardContainer key={idx}>
            <SkeletonCardHeader />
            <SkeletonCardBody />
          </SkeletonCardContainer>
        ))}
      </SkeletonCardsContainer>
    </SkeletonContainer>
  );
};

export { ResourcesClientHomeSkeleton };

const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
  width: 100%;
  height: 100%;
`;

const SkeletonTitle = styled(SkeletonBlock)`
  height: 46px;
`;

const SkeletonCardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 27px;
  row-gap: 34px;
  padding: 20px 0 34px;
`;

const SkeletonCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: auto;
  width: 100%;
  gap: 10px;
  padding: 10px 0;

  ${media.phone} {
    width: calc(50% - 14px);
    min-width: 400;
  }
`;

const SkeletonCardHeader = styled(SkeletonBlock)`
  height: 36px;
  width: 100%;
`;

const SkeletonCardBody = styled(SkeletonBlock)`
  height: 360px;
  width: 100%;
`;
